import {
  Badge,
  Box,
  Center,
  CheckboxCard,
  CheckboxGroup,
  Flex,
  HStack,
  Icon,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const bookingOptionsSelection = [
  {
    title: 'Drop-in',
    description: 'No membership required through a venue to join',
    icon: <MeetingRoomIcon />,
    value: 'dropInAvailable',
    disabled: false,
  },
  {
    title: 'Bookable on FootFall',
    icon: <ImportantDevicesIcon />,
    value: 'bookableOnFootFall',
    disabled: true,
    addon: <Badge variant={'solid'}>Coming soon!</Badge>,
  },
];

const QUERY_KEY = key => `pub_${key}`;

const parseValueFromUrl = (search, key) => {
  const params = new URLSearchParams(search);
  const value = params.get(QUERY_KEY(key));

  return value ? value : false;
};

const SearchFiltersBookingOptions = ({ updateQueryParams }) => {
  const location = useLocation();

  const [bookingOptions, setBookingOptions] = useState(() => {
    const initial = {};
    bookingOptionsSelection.forEach(({ value }) => {
      initial[value] = !!parseValueFromUrl(location.search, value);
    });
    return initial;
  });

  useEffect(() => {
    const nextState = {};
    bookingOptionsSelection.forEach(({ value }) => {
      nextState[value] = !!parseValueFromUrl(location.search, value);
    });
    setBookingOptions(nextState);
  }, [location.search]);

  return (
    <Box>
      <CheckboxGroup>
        <SimpleGrid gap="2">
          <Flex gap={'2'}>
            {bookingOptionsSelection.map(({ value, title, disabled, icon, description, addon }) => (
              <CheckboxCard.Root
                key={value}
                disabled={disabled}
                cursor={disabled ? '' : 'pointer'}
                checked={bookingOptions[value]}
                onCheckedChange={({ checked }) => {
                  setBookingOptions(prev => ({
                    ...prev,
                    [value]: checked,
                  }));

                  updateQueryParams({
                    [`pub_${value}`]: checked ? 'true' : null,
                  });
                }}
                align="center"
                rounded={'xl'}
                bgColor={bookingOptions[value] ? 'gray.50' : ''}
              >
                <CheckboxCard.HiddenInput />
                <CheckboxCard.Control>
                  <CheckboxCard.Content>
                    <Icon fontSize="2xl" mb="2">
                      {icon}
                    </Icon>
                    <CheckboxCard.Label>
                      <Text fontWeight="semibold" textStyle="md" m={0}>
                        {title}
                      </Text>
                    </CheckboxCard.Label>
                    {description && (
                      <CheckboxCard.Description>{description}</CheckboxCard.Description>
                    )}
                  </CheckboxCard.Content>
                </CheckboxCard.Control>
                {addon && (
                  <CheckboxCard.Addon>
                    <Center>
                      <HStack align={'center'}>{addon}</HStack>
                    </Center>
                  </CheckboxCard.Addon>
                )}
              </CheckboxCard.Root>
            ))}
          </Flex>
        </SimpleGrid>
      </CheckboxGroup>
    </Box>
  );
};

export default SearchFiltersBookingOptions;
